import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { OktaCallbackComponent } from '@okta/okta-angular';
import { HomeComponent } from './home/home.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { AuthInterceptor } from './shared/okta/auth.interceptor';
import { environment } from 'src/environments/environment';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PaytmComponent } from './common/paytm/paytm.component';
import { OktaLoginComponent } from './okta-login/okta-login.component';
import { MonitoringDashboardComponent } from './monitoring-dashboard/monitoring-dashboard.component';
import { LoginComponent } from './common/login/login/login.component';


// const oktaConfig = {
//   issuer: environment.issuer,
//   redirectUri: environment.redirectUri,
//   clientId: environment.clientId,
//   useInteractionCodeFlow: true,
//   scopes: ['openid', 'profile', 'email'],
//   pkce: false,
//   disableHttpsCheck: false,
// };

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path:'login',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path:'monitoring-dashboard',
    component:MonitoringDashboardComponent
  }
  ,
  // {
  //   path: 'implicit/callback',
  //   component: OktaCallbackComponent
  // },
  {
    path:'paytm',
    component: PaytmComponent
  }
  ,
  // { path: 'login', redirectTo: 'okta-login', pathMatch: 'full' },
  {
    path:'',redirectTo:'login',pathMatch:'full'
  }
];

@NgModule({ declarations: [
        HomeComponent
    ],
    exports: [RouterModule], imports: [CommonModule,
        RouterModule.forRoot(routes)], providers: [
        // { provide: OKTA_CONFIG, useValue: oktaConfig },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthRoutingModule { }
